
const Certificates = (props) => {

    const certificates = props.certificates
    // console.log(certificates);


    const datamap = certificates?.map((item, index) => {
        return <div className=" col-lg-12 col-xl-6" key={item.id}>
            <div className="certificate-item d-flex">
                <div className="certificate-logo">
                    <img src={`https://amirsabit.4api.ir/uploads/Certificates/${item.cr_image}`} title="" alt="" className="img-fluid" />
                </div>
                <div className="certificate-content">
                    <div className="title">{item.title}</div>
                    {/* <div className="certificate-id">شماره عضویت: 2212552</div> */}
                    <div className="certificate-date">{item.cr_date}</div>
                </div>
            </div>
        </div>
    })

    return (
        <div className="certificates">
            <div className="block-title">
                <h6 className="title">گواهینامه ها</h6>
            </div>
            <div className="row">
                {datamap}
            </div>
        </div>
    )
}
export default Certificates;